const otpDeliveryMechanisms = {
    SMS: 'SMS',
    SMS_PHONE: 'SMS_PHONE',
    EMAIL: 'EMAIL',
    EMAIL_ONLY_OTP: 'EMAIL_ONLY_OTP'
};
export { otpDeliveryMechanisms };
